import { IMG } from '../../const';
import { getNumberAsString, combineValues } from '../../helpers';
import '../../assets/styles/report.scss';
import DiscoveryTab from './DiscoveryTab';
import DesignTab from './DesignTab';

const Tabs = ({
  activeOption,
  results,
  haveDesign,
  designPrice,
  designTime,
  days,
}) => {
  return (
    <>
      {Object.entries(results).map(([key, value]) => (
        <div
          key={key}
          className={`report-page__tab${
            activeOption.id === key ? ' activeTab' : ''
          }`}
        >
          <div className="summary-block">
            <div className="summary-block__label">Summary</div>
            <ul className="summary-block__list">
              <li>
                <div>{value.accuracy}%</div>
                <div>accuracy</div>
              </li>
              <li>
                <div>{value.people_in_team}</div>
                <div>people in team</div>
              </li>
              <li>
                <div>
                  {getNumberAsString(+value.price_min, +value.price_max)}
                </div>
                <div>budget range</div>
              </li>
              <li>
                <div>{combineValues(value.weeks_min, value.weeks_max)}</div>
                <div>{value.weeks_max > 1 ? 'weeks' : 'week'}</div>
              </li>
            </ul>
          </div>

          <div className="features-block">
            <div className="features-block__item">
              <div className="features-block__item-title">Key Features</div>
              <ul>
                {Object.values(value.key_features).map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>

            <div className="features-block__item height-fit-content">
              <div className="features-block__item-title">Team</div>
              <ul>
                {value.team.map((item, index) => (
                  <li key={index}>
                    {item.amount} {item.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="summary-block">
            <div className="summary-block__label">Roadmap</div>
            <ul className="summary-block__roadmap">
              <li>
                <div className="summary-block__roadmap-text">
                  <img
                    src={`${IMG.QUICK_QUOTE}/icons/call-calling.svg`}
                    width="44"
                    height="44"
                    loading="lazy"
                    alt="Book Free consultation"
                  />
                  <div>
                    <h3>Book Free consultation</h3>
                    <p>
                      A quick intro call to understand your needs, goals, and
                      whether we're the right fit.
                    </p>
                  </div>
                </div>
                <div className="summary-block__roadmap-runtime">
                  {value.consultation_minutes} min
                </div>
              </li>

              <li>
                <div className="summary-block__roadmap-text">
                  <img
                    src={`${IMG.QUICK_QUOTE}/icons/search-status.svg`}
                    width="44"
                    height="44"
                    loading="lazy"
                    alt="System Discovery and Specification"
                  />
                  <div>
                    <h3>System Discovery and Specification</h3>
                    <p>
                      Research and validation phase: interviews, competitor
                      analysis, business goals clarification. Helps define the
                      “why” and ensure alignment before solutioning.
                    </p>
                  </div>
                </div>
                <div className="summary-block__roadmap-runtime">
                  {combineValues(
                    value.system_discovery_days_min,
                    value.system_discovery_days_max
                  )}{' '}
                  days
                </div>
              </li>

              {!haveDesign && (
                <li>
                  <div className="summary-block__roadmap-text">
                    <img
                      src={`${IMG.QUICK_QUOTE}/icons/brush.svg`}
                      width="44"
                      height="44"
                      loading="lazy"
                      alt="UI/UX Design"
                    />
                    <div>
                      <h3>UI/UX Design</h3>
                      <p>
                        Design team creates UX flows, high-fidelity UI, and
                        interactive prototypes to visualize the product
                        experience and validate before development.
                      </p>
                    </div>
                  </div>
                  <div className="summary-block__roadmap-runtime">
                    {combineValues(
                      value.design_days_min,
                      value.design_days_max
                    )}{' '}
                    days
                  </div>
                </li>
              )}

              <li>
                <div className="summary-block__roadmap-text">
                  <img
                    src={`${IMG.QUICK_QUOTE}/icons/code.svg`}
                    width="44"
                    height="44"
                    loading="lazy"
                    alt="System development"
                  />
                  <div>
                    <h3>System development</h3>
                    <p>
                      Developers begin building the project following the
                      approved scope and designs, often in iterative sprints.
                    </p>
                  </div>
                </div>
                <div className="summary-block__roadmap-runtime">
                  {combineValues(
                    value.system_development_days_min,
                    value.system_development_days_max
                  )}{' '}
                  days
                </div>
              </li>

              <li>
                <div className="summary-block__roadmap-text">
                  <img
                    src={`${IMG.QUICK_QUOTE}/icons/share.svg`}
                    width="44"
                    height="44"
                    loading="lazy"
                    alt="System Improvement/Knowledge sharing"
                  />
                  <div>
                    <h3>System Improvement/Knowledge sharing</h3>
                    <p>
                      Post-launch activities: bug fixes, user feedback
                      collection, QA testing, and performance optimization.
                    </p>
                  </div>
                </div>
                <div className="summary-block__roadmap-runtime">
                  {combineValues(
                    value.system_improvement_days_min,
                    value.system_improvement_days_max
                  )}{' '}
                  days
                </div>
              </li>
            </ul>
          </div>
        </div>
      ))}
      <DiscoveryTab activeOption={activeOption} />
      <DesignTab
        activeOption={activeOption}
        designPrice={designPrice}
        designTime={designTime}
        days={days}
      />
    </>
  );
};

export default Tabs;
